export default __webpack_public_path__ + "static/media/SellersHouse.ac77f17a.jpg";